import * as React from 'react';

import Gavel56 from './Gavel56';

export const gavel56 = () => <Gavel56 />;

export default {
    title: 'Illustration|Gavel56',
    component: Gavel56,
    parameters: {
        notes: "`import Gavel56 from 'box-ui-elements/es/illustration/Gavel56';`",
    },
};
